const formatSurgeonName = (title?: string, firstName?: string, lastName?: string): string =>
  firstName || lastName ? [title || 'Dr.', firstName, lastName].filter(Boolean).join(' ') : '';

export default formatSurgeonName;
